export default __webpack_public_path__ + "static/media/a011-04.101c04d4.jpg";